/* ============================================================
   DER GROSSE LADEN — Etappe 7 / Phase 7  —  assets/blog.js
   1) «Mehr laden» für den Blog-Index (spiegelt assets/load-more.js,
      aber gescoped auf #blog-grid — fasst load-more.js NICHT an)
   2) Sidebar: Desktop immer offen, Mobile als Dropdown (<details>)
   ============================================================ */
(function () {
  'use strict';

  /* ── 1) Mehr laden / Nachladen von Artikeln ─────────────────────── */
  function initLoadMore() {
    var btn = document.querySelector('.blog-load-more');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-next-url');
      if (!url) return;

      var original = btn.textContent;
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.textContent = 'Lädt …';

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#blog-grid');
          var grid = document.querySelector('#blog-grid');

          if (newGrid && grid) {
            Array.prototype.forEach.call(newGrid.children, function (node) {
              grid.appendChild(document.importNode(node, true));
            });
          }


          /* ---- Die Adresse nennt die Seite, auf der man ist (28.09.2026) ----------
             VORBILD clearspring.co.uk, dort nachgemessen: Nach zwei Klicks auf
             "Load more" steht dort /collections/all?page=3 in der Adresszeile,
             history.length bleibt dabei bei 2 - also replaceState, kein neuer
             Verlaufseintrag.

             WARUM DAS DER ENTSCHEIDENDE PUNKT IST:
             Beim Zurueckkommen holt der Browser die Seite normalerweise aus seinem
             Vor-/Zurueck-Speicher (bfcache) - fertig gerendert, mit allen Kacheln und
             der Scrollposition. Gemessen am 28.09.2026: Live 16 ms, null Anfragen,
             Position auf den Pixel genau. Genau so machen es clearspring.co.uk,
             avocadostore.de und waschbaer.de, alle bei 12-16 ms.

             Greift der Speicher nicht - Seite neu geladen, neuer Tab, wenig Arbeits-
             speicher, oder auf dem Dev-Server, der ihn mit Cache-Control: no-store
             ausdruecklich verbietet -, liefert der Server die Seite neu. Und dann
             entscheidet die ADRESSE, was er liefert: Ohne page-Angabe die erste
             Portion (und unser Skript musste den Rest muehsam nachladen, sichtbar
             ruckelnd), mit page-Angabe genau die Seite, auf der man war.

             Der Preis ist derselbe wie bei Clearspring: Zurueck kommt man auf SEITE N,
             nicht auf die Sammlung aller bis dahin geladenen Kacheln. Dafuer passiert
             es in einem einzigen ruhigen Sprung statt als Aufbau vor den Augen.

             replaceState und nicht pushState: Sonst braeuchte jeder Klick auf
             "Mehr laden" einen eigenen Zurueck-Schritt, und man kaeme aus der Liste
             nicht mehr heraus.

             Filter und Sortierung bleiben erhalten, weil die Adresse aus
             paginate.next.url stammt und deren Parameter mitfuehrt. */
          /* ABGESCHALTET am 28.09.2026, einen Tag nach dem Einbau.

             Eingebaut war es als Nachbau von clearspring.co.uk: Dort schreibt "Load more"
             die geladene Seite per replaceState in die Adresse, und beim Zurueckkommen
             liefert der Server dann genau diese Seite.

             WARUM ES HIER NICHT PASST: Clearspring hat unter dem Knopf eine SICHTBARE
             Seitenleiste (1 2 3 ... 7). Dort ist eine Seitenzahl eine Groesse, die der
             Kunde kennt und anklicken kann. Unser Shop hat nur "Mehr laden" - eine
             durchgehende Liste ohne Seitenbegriff. In der Adresse stand dann eine Zahl,
             die im Laden nirgends vorkommt.

             Der Nutzer hat es am klarsten beschrieben: ?page=14 eingeben, es erscheint
             eine Liste, die oben anfaengt, und die naechste Charge heisst ?page=15 -
             waehrend man selbst "Seite 1 und Seite 2" sieht. Die Zahl zaehlt die Charge
             in der GESAMTSAMMLUNG, nicht die geladenen Chargen. Beides gleichzeitig kann
             eine Zahl nicht bedeuten.

             WAS BLEIBT: Der Gewinn kam ohnehin nicht von der Adresse, sondern davon, den
             Platz sofort zu reservieren und sofort zu springen, bevor irgendetwas geladen
             ist (siehe wiederherstellen in assets/zurueck-und-scrollposition.js). Das
             funktioniert ohne Seitenzahl genauso - die Zahl der geladenen Kacheln steht
             im Sitzungsspeicher.

             NICHT GELOESCHT, nur abgeschaltet: Sollte spaeter eine sichtbare Seitenwahl
             dazukommen, ist dies die Zeile, die dann wieder auf true gehoert.
             Bewusst ueber eine Konstante und nicht als Kommentarblock: Innerhalb stehen
             eigene Kommentarklammern, und die verschachteln sich in JavaScript nicht. */
          const ADRESSE_MIT_SEITE = false;
          if (ADRESSE_MIT_SEITE && window.history && history.replaceState) {
            try {
              history.replaceState(history.state, '', url);
            } catch (fehler) {
              /* Manche Browser verweigern replaceState bei zu vielen Aufrufen -
                     dann bleibt die Adresse eben stehen, sonst aendert sich nichts. */
            }
          }

          var nextBtn = doc.querySelector('.blog-load-more');
          var nextUrl = nextBtn ? nextBtn.getAttribute('data-next-url') : null;

          if (nextUrl) {
            btn.setAttribute('data-next-url', nextUrl);
            btn.classList.remove('is-loading');
            btn.disabled = false;
            btn.textContent = original;
          } else {
            var wrap = btn.closest('.blog-load-more-wrap');
            (wrap || btn).remove();
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = original;
        });
    });
  }

  /* ── 2) Sidebar: Desktop offen / Mobile Dropdown ──────────── */
  function initSidebar() {
    var details = document.querySelector('details.blog-sidebar');
    if (!details) return;

    var mq = window.matchMedia('(min-width: 750px)');

    function apply() {
      details.open = true;
    }

    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function () {
        details.dataset.touched = '1';
      });
    }

    apply();
    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else if (mq.addListener) {
      mq.addListener(apply); // Safari < 14
    }
  }

  function init() {
    initLoadMore();
    initSidebar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();